/**
 * La factura extranjera que corresponde a una partida.
 *
 * `foreignInvoice.amount` es el TOTAL de la factura, uno solo, pero la misma factura
 * cuelga de TODAS las entradas de la partida: recorrer `entries.bills` la devuelve
 * repetida. Sumarla una vez por entrada —y encima mezclar otras facturas pegadas a esas
 * mismas entradas— daba múltiplos del importe real.
 *
 * Caso de prod del 2026-10-09, factura MCI28926-10082445: la posición del pedido
 * 4517583824 tiene dos entradas con esa factura más otra factura vieja de 102,240
 * colgada de la 5122567081, así que la pantalla mandó al aprobar
 *
 *     100,310.40 × 2 + 102,240 = 302,860.80
 *
 * El backend lo leyó como una edición del renglón, le sumó las otras dos posiciones y
 * guardó 454,924.80, que es el `Valor_neto` que recibió SAP contra un `Valor_bruto` de
 * 249,984.
 *
 * Se queda con una sola factura por id, descarta las rechazadas y devuelve la más
 * reciente: el mismo criterio que usa el backend al aprobar (`getUUIDBills`).
 */
export const foreignBillOf = (item) => {
    const porFactura = new Map();

    (item?.entries || []).forEach((entry) => {
        (entry?.bills || []).forEach((bill) => {
            if (!bill || !bill.foreignInvoice || bill.billStatus === 'REJECTED') return;
            const clave = bill.id || bill.cfdiUuid;
            if (!porFactura.has(clave)) porFactura.set(clave, bill);
        });
    });

    return [...porFactura.values()].sort(
        (a, b) =>
            new Date(b.foreignInvoice.invoiceDate).getTime() -
            new Date(a.foreignInvoice.invoiceDate).getTime()
    )[0];
};
